export enum TabEnum {
    Station = 'Stations',
    Source = 'Sources',
}

export enum TabRouteEnum {
    Station = 'station',
    Source = 'source',
}
